<template>
	<b-container fluid>
		<b-row v-if="!isLogin  && !isNewPassword">
			<alert-loading v-if="configLoading"></alert-loading>
			<b-navbar v-if="!configLoading" toggleable="md" class="col-md-3 col-lg-2 d-block sidebar">
				<a class="nav-logo">{{configCompany.name}}</a>
				<b-nav-toggle target="nav_collapse"></b-nav-toggle>
				<b-collapse is-nav id="nav_collapse">
					<b-navbar-nav class="flex-column">
						<li class="nav-item"><router-link :to="{ name: 'CustomerList' }" class="nav-link"><svg-icon name="client" size="24"/>Klienci</router-link></li>
						<li class="nav-item"><router-link :to="{ name: 'AgreementList' }" class="nav-link"><svg-icon name="agreement" size="24"/>Umowy</router-link></li>
						<li class="nav-item"><router-link :to="{ name: 'FactoredInvoiceList' }" class="nav-link"><svg-icon name="factoredInvoice" size="24"/>Faktury</router-link></li>
						<li class="nav-item"><router-link :to="{ name: 'DebtorList' }" class="nav-link"><svg-icon name="deptor" size="24"/>Dłużnicy</router-link></li>
						<li class="nav-item"><router-link :to="{ name: 'InvoiceList' }" class="nav-link"><svg-icon name="invoice" size="24"/>Sprzedaż</router-link></li>
						<li class="nav-item"><router-link :to="{ name: 'ReportList' }" class="nav-link"><svg-icon name="report" size="24"/>Raporty</router-link></li>
						<li v-if="checkPrivilege('ROLE_ADMIN')" class="nav-item nav-item-separated"><router-link :to="{ name: 'UserList' }" class="nav-link"><svg-icon name="user" size="24"/>Użytkownicy</router-link></li>
						<router-link v-if="checkPrivilege('ROLE_ADMIN')" tag="li" :to="{ name: 'settings' }" class="nav-item nav-item--parent">
							<a class="nav-link"><svg-icon name="settings" size="24"/>Ustawienia</a>
							<ul>
								<li><router-link :to="{ name: 'CurrencyTypeList' }" class="nav-link">Waluty</router-link></li>
								<li><router-link :to="{ name: 'FileTypeList' }" class="nav-link">Pliki</router-link></li>
								<li><router-link :to="{ name: 'TransferTypeList' }" class="nav-link">Przelewy</router-link></li>
								<li><router-link :to="{ name: 'CompanyShow' }" class="nav-link">Firma</router-link></li>
								<li><router-link :to="{ name: 'InvoicePaymentTypeList' }" class="nav-link">Płatności</router-link></li>
								<li><router-link :to="{ name: 'InvoiceTaxTypeList' }" class="nav-link">Stawki VAT</router-link></li>
							</ul>
						</router-link>
					</b-navbar-nav>
				</b-collapse>
			</b-navbar>
			<main v-if="!configLoading" class="col-md-9 col-lg-10 content" role="main">
				<b-row>
					<nav class="navbar-user col-sm-12">
						<p class="text-right"><a v-on:click="logout" href="" class="link">Witaj, {{ userFullName }} <svg-icon name="logout" /></a></p>
					</nav>
				</b-row>
				<b-row>
					<router-view></router-view>
				</b-row>
				<footer>
					<p class="text-right">&copy; {{ currentYear }} - Syndykat Katowice</p>
				</footer>
			</main>
		</b-row>
		<b-row v-if="isLogin" align-v="center" class="login-row justify-content-center">
			<login></login>
		</b-row>
		<b-row v-if="isNewPassword" align-v="center" class="login-row justify-content-center">
			<new-password></new-password>
		</b-row>
	</b-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import security from './utils/security';

	export default {
		computed: {
			currentYear() {
				return new Date().getFullYear()
			},
			isLogin() {
				return this.$route.name == 'Login';
			},
			isNewPassword() {
				return this.$route.name == 'NewPassword';
			},
		    ...mapGetters({
                userFullName: 'security/authentication/userFullName',
                configLoading: 'config/config/loading',
                configCompany: 'config/config/company',
              }
			)
		},
        methods: {
          checkPrivilege: (role ) => security.checkPrivilege(role),
		  ...mapActions({
            logout: 'security/authentication/logout'
          }),
		  absolutePath(url){
            return `${location.origin}/${url}`
		  }
        },
	}
</script>

<style lang="scss">
	@import './assets/styles/_style.scss';

  .autocomplete ul{
	  color: red;
	  z-index: 10;
  }
</style>


// WEBPACK FOOTER //
// App.vue?a8297fcc